import script from "./AddCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCard.vue?vue&type=script&setup=true&lang=js"

import "./AddCard.vue?vue&type=style&index=0&id=0ca9dbab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca9dbab"]])

export default __exports__